import { render, staticRenderFns } from "./AstaAssegna.vue?vue&type=template&id=4d21f153&scoped=true&"
import script from "./AstaAssegna.vue?vue&type=script&lang=js&"
export * from "./AstaAssegna.vue?vue&type=script&lang=js&"
import style0 from "./AstaAssegna.vue?vue&type=style&index=0&id=4d21f153&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d21f153",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d21f153')) {
      api.createRecord('4d21f153', component.options)
    } else {
      api.reload('4d21f153', component.options)
    }
    module.hot.accept("./AstaAssegna.vue?vue&type=template&id=4d21f153&scoped=true&", function () {
      api.rerender('4d21f153', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/AstaAssegna.vue"
export default component.exports